export default __webpack_public_path__ + "locales/hy-AM/EmptyView.json?hash=15492b30927416b95f3f5c176f62ed97";